(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //
    //   <px-simple-ui-select
    //     ng-if="scannerSelect.orientation"
    //     select-for="'WORKFLOW'"
    //     list="scannerSelect.orientation"
    //     pre-selected-item="scannerSelect.orientation[0]"
    //     placeholder="'numse'"
    //     sort-by-name="true"
    //     select-by-id="true"
    //     select-identifier="'FILE_NAME_CONTEXT'"
    //     dynamic="true"
    //     disable="true/false"
    //     callback="test(item)">
    //   </px-simple-ui-select>


  function pxSimpleUiPaginatedSelect(
    $timeout, $filter, toastr, $http, $rootScope, $injector, $window
  ) {
    return {
      restrict: 'EA',
      scope: {
        disable: '=disable',
        autoInit: '=autoInit',
        preSelectedItem: '=preSelectedItem',
        placeholder: "=placeholder",
        selectById: '=selectById',
        selectIdentifier: '=selectIdentifier',
        pagingObject: '=pagingObject',
        pagingService: '=pagingService',
        resetSelection: "=resetSelection",
        filters: '=filters',
        endpoint: '=endpoint',
        callback: '&callback'
      },
      templateUrl: 'app/directives/simple-ui-paginated-select/simple-ui-paginated-select.template.html',
      link: function(scope, element) {


        let scrollEnd = null;
        let containerHeight = null;

        /** @type {DestinationProfileService} */
        const service = $injector.get([scope.pagingService]);
        const pagingParams = $injector.get([scope.pagingObject]);

        /** @type {ListServicePagingParams} */
        scope.pagingParams = new pagingParams();

        if (scope.filters) {
          scope.filters.forEach(filter => {
            scope.pagingParams.pagingCriteria[filter.key] = filter.value;
          })
        }

        scope.pagingParams.pagingCriteria.pageSize = 5
        scope.item = {selected: undefined};
        scope.loadingPage = true;
        scope.totalPages = null;
        scope.searchString = '';
        scope.dependsOn = undefined;

        (() => {
          setGlobalListeners();
          if (scope.autoInit) {
            getFirstPage();
          }
        })();


        function resetList () {
          scope.list = [];
          angular.element(`#${scope.selectIdentifier}`).scrollTop(0)
        }

        function getFirstPage () {
          scope.pagingParams.pagingCriteria.page = 0;
          service.getList(scope.endpoint, scope.pagingParams).then(function(response) {
            scope.internalDisable = false;
            resetList()
            scope.totalPages = response.page.totalPages;
            scope.list = formatToSelectList(response.list, response.mapType)
            scope.loadingPage = false;
            setListeners()
          }).catch(function(error){});
        }

        function getNextPage () {
          if ((scope.endpoint || scope.filters) && scope.pagingParams) {

            if (!scope.loadingPage && scope.totalPages > scope.pagingParams.pagingCriteria.page + 1) {
              scope.loadingPage = true;
              scope.pagingParams.pagingCriteria.page += 1;
              service.getList(scope.endpoint, scope.pagingParams).then(function(response){
                if (response.list) {
                  scope.list = scope.list.concat(formatToSelectList(response.list, response.mapType));
                }
                scope.loadingPage = false;
              }).catch(function(error){});
            }
          }
        }

        function textSearch () {
          scope.pagingParams.pagingCriteria.match = scope.searchString;

          $timeout(function () {
            getFirstPage();
          }, 500)
        };

        function formatToSelectList(list, mapType) {
          switch (mapType) {
            case 'fields':
              return list.map((item) => {
                return {
                  name: item.info.possibleDisplayValue,
                  value: item.info.possibleValue,
                }
              })
            default:
              return list;
          }
        };

        scope.eventHandlersSet = false;

        function setListeners() {
          if (!scope.eventHandlersSet) {
            scope.eventHandlersSet = true;
            angular.element(`#${scope.selectIdentifier}`).on('scroll', scrollHandler);
            type();
          }
        }

        function scrollHandler (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 30;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.pagingParams.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        }

        const delay = {
          setup() {
            this.cancel()
            this.timer = setTimeout((msg) => {
              textSearch()
            }, 500);
          },

          cancel() {
            clearTimeout(this.timer);
          }
        };


        function type () {
          var searchInput = element.querySelectorAll('input.ui-select-search');
          scope.$watch(function() {
            return searchInput[0].value;
          }, function(a, b) {
            if (a !== b) {
              scope.searchString = a;
              delay.setup();
            } else {
              scope.searchString = a;
              delay.cancel();
            }
          })
        }

        scope.changeItem = function (item) {

          if (scope.resetSelection) {
            // Reset the list of available items when an item is selected. This is good
            // when the paginated select represents a hierarchical selector where the
            // list of items can change to the sub-items of the currently selected item.
            resetList();
          }

          scope.callback({item: item.selected});

          if (item.selected.value === '..') {
            // Empty the HTML SELECT element after the ".." item was selected
            scope.item.selected = undefined;
          }
        }

        var SELECT_IDENTIFIER_listener;
        var SELECT_IDENTIFIER_RESET_UI_SELECT_listener;

        /**
         * Refresh the component based on the underlying model after an item was selected.
         *
         * @param {Event} event
         * @param {{ endpoint: String, selectedItem: null|{ name: String, value: String }, enabled: boolean, dependsOn: String}} data
         */
        function handleUpdateEvent(event, data) {

          scope.item.selected = data.selectedItem;
          scope.endpoint = data.endpoint;
          scope.internalDisable = !data.enabled;
          if (data.enabled && data.dependsOn !== scope.dependsOn) {
            scope.dependsOn = data.dependsOn;
            getFirstPage();
          }
        }

        function setGlobalListeners () {
          SELECT_IDENTIFIER_listener = $rootScope.$on(`${scope.selectIdentifier}_UPDATE`, handleUpdateEvent);

          SELECT_IDENTIFIER_RESET_UI_SELECT_listener = $rootScope.$on(`${scope.selectIdentifier}_RESET_UI_SELECT`, function(event, data) {
            scope.item.selected = undefined;
            scope.internalDisable = true;
          })
        }

        scope.$on('$destroy', function() {
          angular.element(`#${scope.selectIdentifier}`).off('scroll', scrollHandler);
          SELECT_IDENTIFIER_RESET_UI_SELECT_listener();
          SELECT_IDENTIFIER_listener();
          scope.eventHandlersSet = false;
        });

      }
    };
  }

  pxSimpleUiPaginatedSelect.$inject = ['$timeout', '$filter', 'toastr', '$http', '$rootScope', '$injector', '$window'];

  angular
    .module('printix-admin')
    .directive('pxSimpleUiPaginatedSelect', pxSimpleUiPaginatedSelect);

})();
